import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { Gallery, Preview, Thumbnails } from '../../components/Gallery';
import { IProjectImage } from '../../types/builders';
import { aspectRatio } from './constants';

export interface IGalleryContainerProps {
  images: IProjectImage[];
}

export const GalleryContainer: React.FC<IGalleryContainerProps> = ({ images }) => {
  const previewImage = images[0]?.thumbnail || '';
  const thumbnailsImages = images.slice(1);
  const deviceType = useDeviceType();
  const { preview, thumbnail } = aspectRatio[deviceType];

  return (
    <Gallery>
      <Preview image={previewImage} aspectRatio={preview} fullHeight={deviceType === 'tablet'} />
      {/* Отображаем миниатюры, когда их больше одной */}
      {thumbnailsImages.length > 1 && <Thumbnails images={thumbnailsImages} aspectRatio={thumbnail} />}
    </Gallery>
  );
};
